// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"ef3bcd54","150":"a9271911","220":"734dd961","923":"e6288697"}[chunkId] + ".chunk.js";
};